import {Vector3} from "@react-three/fiber";
import {useControls} from "leva";
import {useMemo, useRef} from "react";
import Avatar from "../components/Avatar";
import {useStore} from "../store";

export default function AvatarGroup() {
    const personas = useStore((state) => state["personas"]);
    const takenPointsRef = useRef<Vector3[]>([])
    const disabledAnchorPositions = useStore((state) => state["disabledAnchorPositions"]);
    const selectedAnchorPosition = useStore((state) => state["selectedAnchorPosition"]);
    const disabledAnchorConfig = useMemo(() => {
        const config: Record<string, any> = {};
        disabledAnchorPositions.forEach((pos, index) => {
            config[`pos-${index}`] = {
                hide: true,
                step: 0.01,
                value: {x: pos.x, y: pos.y},
            };
        });
        return config;
    }, [disabledAnchorPositions]);

    const {selected} = useControls({
        selected: {
            step: 0.01,
            value: {
                x: selectedAnchorPosition.x,
                y: selectedAnchorPosition.y,
            },
        },
    });

    const deselected = useControls("disabled anchors", disabledAnchorConfig, {
        collapsed: true,
    }, [disabledAnchorConfig]);

    const Personas = useMemo(
        () =>
            personas.map((persona, index) => {
                return (
                    <Avatar
                        key={persona.key}
                        index={index}
                        persona={persona}
                        count={personas.length}
                        takenPoints={takenPointsRef}
                    />
                );
            }),
        [personas]
    );

    return (
        <group>
            {Personas}
            <mesh
                name="SelectedAnchorPosition"
                position={[selected?.x, selected?.y, selectedAnchorPosition?.z]}
                visible={false}
            >
                <sphereBufferGeometry args={[0.02, 5, 5]}/>
                <meshBasicMaterial color="red"/>
            </mesh>
            {disabledAnchorPositions.map((vec3, index) => {
                return (
                    <mesh
                        name={`DisabledAnchorPosition${index}`}
                        key={`DisabledAnchorPosition${index}`}
                        position={[
                            deselected[`pos-${index}`]?.x,
                            deselected[`pos-${index}`]?.y,
                            vec3.z,
                        ]}
                        visible={false}
                    >
                        <sphereBufferGeometry args={[0.02, 5, 5]}/>
                        <meshBasicMaterial color="blue"/>
                    </mesh>
                );
            })}
        </group>
    );
}
